import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { NavLink } from "react-router-dom";
import PaginationComponent from "components/Pagination/Pagination";
import usePagination from "hooks/usepagination";
import {
  Button,
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Form,
  Col,
  FormGroup,
} from "reactstrap";
import api from "service/api";
import ModalConfirm from "../components/Modal/ModalConfirm";
import qualityApi from "service/qualityApi";
import { CookieTool } from "utils/CookieTool";

const SLAConfiguration = () => {
  const { register, handleSubmit, reset } = useForm();
  const [range, setRange] = useState(0);
  const [info, setInfo] = useState([]);
  const { actualPage } = usePagination();
  const [offset, setOffset] = useState(actualPage || 1);
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [clients, setClients] = useState([]);
  const permissions = CookieTool.getLarge("permissions");

  useEffect(() => {
    qualityApi
      .get(`/sla/configuration?page=${offset}&limit=${Number(limit)}&${search}`)
      .then((response) => {
        setRange(response.total ?? 0);
        setInfo(response.data.records || []);
      })
      .catch(() => {
        toast.error("Erro ao buscar configurações.");
        return;
      });

    api
      .get(`/clients?page=1&limit=10000`)
      .then((response) => {
        const clients = response.data;
        const clientOptions = [...clients.clients];
        setClients(clientOptions);
      })
      .catch(() => {
        toast.error("Erro ao recuperar clientes!");
        return;
      });
  }, [offset, search, limit]);

  const handleDelete = (id) => {
    qualityApi
      .delete(`/sla/configuration/${id}`)
      .then(() => {
        toast.success("Configuração de SLA excluída com sucesso!");
        setSearch("");
        setInfo((prevInfo) => prevInfo.filter((item) => item.id !== id));
        reset();
      })
      .catch(() => {
        toast.error("Erro ao excluir configuração de SLA.");
      });
    setSearch("");
  };

  const onSubmit = (data) => {
    const { client } = data;
    let query = "";
    if (client) {
      query += `client=${client}&`;
    }
    setSearch(query);
  };

  const clearSearch = () => {
    let query = "";
    setSearch(query);
    reset();
  };

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };

  return (
    <>
      <Container className="mt-2" fluid>
        <div className="header bg-gradient-info pb-8 pt-2 pt-md-5 d-flex align-items-center justify-content-center flex-column ">
          <div className="container-fluid">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Row>
                <Col lg={5}>
                  <FormGroup>
                    <label className="text-white mr-2 ml-2">Cliente</label>
                    <select
                      name="client"
                      id="client"
                      className="Input"
                      style={{
                        display: "block",
                        width: "100%",
                        minWidth: "180px",
                        height: "calc(1.5em + 1.25rem + 2px)",
                        padding: "0.625rem 0.75rem",
                        fontSize: "0.875rem",
                        fontWeight: "400",
                        lineHeight: "1.5",
                        color: "#8898aa",
                        backgroundColor: "#fff",
                        backgroundClip: "padding-box",
                        border: "1px solid #cad1d7",
                        borderRadius: "0.375rem",
                        boxShadow: "none",
                        transition:
                          "all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
                      }}
                      {...register("client")}
                    >
                      <option value="">Selecione</option>
                      {clients.map((client, index) => {
                        return (
                          <option value={client.id} key={index}>
                            {client.name}
                          </option>
                        );
                      })}
                    </select>
                  </FormGroup>
                </Col>
                <Col lg={1} className="justify-content-end d-flex flex-column">
                  <FormGroup>
                    <Button
                      className="Button ml-2"
                      type="submit"
                      style={{ height: "50px" }}
                    >
                      Buscar
                    </Button>
                  </FormGroup>
                </Col>
                <Col lg={1} className="justify-content-end d-flex flex-column">
                  <FormGroup>
                    <Button
                      className="Button ml-2"
                      onClick={clearSearch}
                      style={{ height: "50px" }}
                    >
                      Limpar
                    </Button>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </Container>
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex ml-2">
                <select
                  style={{
                    display: "block",
                    width: "80px",
                    height: "35px",
                    fontSize: "0.875rem",
                    lineHeight: "1.5",
                    color: "#8898aa",
                    backgroundColor: "#fff",
                    backgroundClip: "padding-box",
                    border: "1px solid #cad1d7",
                    borderRadius: "0.375rem",
                    boxShadow: "none",
                    transition:
                      "all 0.2s cubic-bezier(0.68, -0.55, 0.265, 1.55)",
                    marginLeft: "10px",
                  }}
                  name="limit"
                  id="limit"
                  className="Input"
                  value={limit}
                  onChange={handleLimitChange}
                >
                  <option value="10">10</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th>Cliente</th>
                    {permissions?.includes("update:segment") && <th>Editar</th>}
                    {permissions?.includes("remove:segment") && (
                      <th>Excluir</th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {info &&
                    info.length > 0 &&
                    info?.map((item) => (
                      <tr key={item?.id}>
                        <td>{item?.clientName}</td>
                        {permissions?.includes("update:segment") && (
                          <td>
                            <NavLink
                              to={`/admin/sla-configuration-form?id=${item?.id}`}
                              activeClassName="active"
                            >
                              Editar
                            </NavLink>
                          </td>
                        )}
                        {permissions?.includes("remove:segment") && (
                          <td>
                            <ModalConfirm
                              id={item.id}
                              modalText={`Esta ação irá excluir a configuração de SLA, você tem certeza?`}
                              handler={() => {
                                handleDelete(item?.id);
                              }}
                              icon={"fas fa-trash"}
                            />
                          </td>
                        )}
                      </tr>
                    ))}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                <nav aria-label="...">
                  <PaginationComponent
                    limit={limit}
                    total={range}
                    offset={offset}
                    setOffset={setOffset}
                  />
                </nav>
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default SLAConfiguration;
